// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const DraggableBlockMenuOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 12 19","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M2.5 7.5a2 2 0 102 2 2 2 0 00-2-2zm0 7a2 2 0 102 2 2 2 0 00-2-2zm7-10a2 2 0 10-2-2 2 2 0 002 2zm-7-4a2 2 0 102 2 2 2 0 00-2-2zm7 14a2 2 0 102 2 2 2 0 00-2-2zm0-7a2 2 0 102 2 2 2 0 00-2-2z","stroke":"currentColor"}}]},"name":"draggable-block-menu","theme":"outlined"};

const DraggableBlockMenuOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={DraggableBlockMenuOutlinedSvg} />;
  DraggableBlockMenuOutlined.displayName = 'DraggableBlockMenuOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(DraggableBlockMenuOutlined);
